export default __webpack_public_path__ + "static/seoul-garden-61a3b6f087f54cdd724e2623440e0b5b.png";